import {lazy} from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-components/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const AccountHistory = Loadable(lazy(() => import('views/history/account')));
const StorageHistory = Loadable(lazy(() => import('views/history/storage')));
const Contract = Loadable(lazy(() => import('views/billing/contract')));
const StatementTest = Loadable(lazy(() => import('views/billing/statement')));
const MailTest = Loadable(lazy(() => import('views/manage/mail')));

// sample page routing
// const SamplePage = Loadable(lazy(() => import('views/sample-page')));

const Temp = Loadable(lazy(() => import('views/Temp')));

// ==============================|| MAIN ROUTING ||============================== //

export const buildMainRoutes = (children) => {
    return {
        path: '/',
        element: <MainLayout/>,
        children
    }
}

export const CHILDREN = [
    {
        path: '/',
        element: <DashboardDefault/>
    },
    {
        path: 'dashboard',
        children: [
            {
                path: 'active',
                element: <DashboardDefault/>
            }
        ]
    },
    {
        path: 'search',
        children: [
            {
                path: 'account',
                element: <Temp src="/account/list"/>
            },
            {
                path: 'team',
                element: <Temp src="/team/list"/>
            },
            {
                path: 'member',
                element: <Temp src="/member/list"/>
            }
        ]
    },
    {
        path: 'billing',
        authority: 'BILLING_VIEW',
        children: [
            {
                path: 'contract',
                element: <Contract/>
            },
            {
                path: 'promotion',
                element: <Temp src="/payment/promotion/list"/>
            },
            {
                path: 'statement',
                element: <Temp src="/payment/billing/list"/>
            },
            {
                path: 'statement-test',
                element: <StatementTest/>
            }
        ]
    },
    {
        path: 'history',
        authority: 'HISTORY_VIEW',
        children: [
            {
                path: 'account',
                element: <AccountHistory/>
            },
            {
                path: 'old-account',
                element: <Temp src="/history/accounts"/>
            },
            {
                path: 'push',
                element: <Temp src="/history/push/list"/>
            },
            {
                path: 'event',
                element: <Temp src="/history/event/list"/>
            },
            {
                path: 'platform',
                element: <Temp src="/history/platform/list"/>
            },
            {
                path: 'storage',
                element: <StorageHistory/>
            }
        ]
    },
    {
        path: 'bulk',
        authority: 'BULK_VIEW',
        children: [
            {
                path: 'member',
                element: <Temp src="/bulk/member"/>
            },
            {
                path: 'organization',
                element: <Temp src="/bulk/organization"/>
            }
        ]
    },
    {
        path: 'manage',
        children: [
            {
                path: 'forceUpdate',
                element: <Temp src="/setting/forceUpdate"/>
            },
            {
                path: 'mail',
                element: <MailTest/>
            }
        ]
    }
]
